
export const environment = {
  production: false,
  apiUrl: 'https://app.sfe.go.cr/SynergyAPI/',
  client: 2,
  clientId: 'ngWebAdmin',
  clientSecret: '123@abc',
  authMethod: 'LDAP', //DB - LDAP

  MAXALLOWEDFILESIZE: 10485760,
  IDLETIME: 1200,
  IDLETIMEOUT: 60,
  ASSETSROUTE: "assets/",

  URLFOTOPERFIL: "assets/img/users/user.png"
};



// WEBPACK FOOTER //
// C:/Synergy/Projects/SFE/Synergy.UI/src/environments/environment.ts